import React, { useEffect, useRef, useState } from "react";

import "./UpdateAvailableButton.css";

const VERSION_URL = "/version.json";
const POLL_INTERVAL_MS = 3 * 60 * 1000;
const DISMISSED_STORAGE_KEY = "chicchic.update.dismissedVersion";

async function fetchVersionInfo() {
  const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
    cache: "no-store",
  });

  if (!res.ok) {
    throw new Error(`Version check failed (${res.status})`);
  }

  return res.json();
}

export default function UpdateAvailableButton() {
  const loadedVersionRef = useRef("");
  const [availableVersion, setAvailableVersion] = useState("");

  useEffect(() => {
    let cancelled = false;

    const checkVersion = async () => {
      try {
        const data = await fetchVersionInfo();
        if (cancelled) return;

        const remoteVersion = String(data?.version || "").trim();
        if (!remoteVersion) return;

        if (!loadedVersionRef.current) {
          loadedVersionRef.current = remoteVersion;
          return;
        }

        if (remoteVersion === loadedVersionRef.current) {
          setAvailableVersion("");
          return;
        }

        const dismissedVersion = localStorage.getItem(DISMISSED_STORAGE_KEY);
        setAvailableVersion(dismissedVersion === remoteVersion ? "" : remoteVersion);
      } catch (err) {
        // Version checks are intentionally non-blocking.
        console.warn("update version check failed:", err?.message || err);
      }
    };

    checkVersion();
    const timer = window.setInterval(checkVersion, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  if (!availableVersion) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISSED_STORAGE_KEY, availableVersion);
    setAvailableVersion("");
  };

  return (
    <div className="cc-update-button-wrap" role="status" aria-live="polite">
      <button
        type="button"
        className="cc-update-button"
        onClick={() => window.location.reload()}
      >
        อัพเดทเวอร์ชั่นใหม่
      </button>
      <button
        type="button"
        className="cc-update-dismiss"
        aria-label="ปิดแจ้งเตือนอัพเดท"
        onClick={dismiss}
      >
        ×
      </button>
    </div>
  );
}
